import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import NotFound from "@/views/NotFound.vue";
import Login from "@/views/Login.vue";
import Admin from "@/views/Admin.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  // example of redirecting
  {
    path: "/home",
    redirect: { name: "home" },
  },

  {
    path: "/login",
    name: "login",
    component: Login,
  },

  {
    path: "/admin/",
    name: "adminPage",
    component: Admin,
    meta: { requiresAuth: true },
  },

  {
    path: "/admin/edit/:id",
    name: "adminEdit",
    component: Admin,
    meta: { requiresAuth: true },
  },

  {
    path: "/:catchAll(.*)",
    name: "Not  Found",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem("user");

  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next("/login");
  }
  next();
});

export default router;
